import { IconError404 } from "@tabler/icons-react";
import { Wrapper } from "../components/layout/wrapper";
import { defineMessages, useIntl } from "react-intl";
import { ArticleType, buildSearchUrl } from "@shared/url";
import { useLocaleFormatter } from "@ct-react/locale";
import { menu_translations } from "../i18n/sharable-defs";
import { Head } from "../components/layout/head";
import { HttpStatus } from "../contexts/http-status";

import "./not-found.scss"

const transDefs = defineMessages({
  error_text_1: { id: "error.text-1", defaultMessage: "Oups ! Cette page n'existe pas..." },
  error_text_2: { id: "error.text-2", defaultMessage: "Voici quelques lien qui pourrait vous intéresser" },
});

const NotFoundPage = () => {
    const intl = useIntl();
    const { transLib } = useLocaleFormatter();

  return (
    <Wrapper.Centered className="error">
      <HttpStatus code={404} />
      <Head><meta name="robots" content="noindex" /></Head>
      <IconError404 className="picto" />
      <p>{intl.formatMessage(transDefs.error_text_1)}</p>
      <p>{intl.formatMessage(transDefs.error_text_2)} :</p>
      <ul>
        <li><a href="/" className="btn link outline small">{intl.formatMessage(menu_translations.home)}</a></li>
        {[ ArticleType.RENTAL, ArticleType.SEASONAL, ArticleType.ANNUAL ]
        .map(t => (<li key={t}><a href={buildSearchUrl(t)} className="btn link outline small">{transLib.match("articleTypes", t)}</a></li>))}
        <li><a href={buildSearchUrl(ArticleType.SALE)} className="btn link outline small">{transLib.match("articleTypes", ArticleType.SALE)}</a></li>
      </ul>
    </Wrapper.Centered>);
}

export default NotFoundPage;
